import { call, put, takeLatest, select } from "redux-saga/effects";
import { initialize, startSubmit, stopSubmit, getFormValues } from "redux-form";
import { getLoadPreferencesUrl, getUpdatePreferencesUrl } from "../../api/UserApi";
import api from "../../api/api";
import { showAlert } from "../../actions";
import mixpanel from "../../services/mixpanel";

function* handleLoadPreferences() {
  const loadPreferenceRequest = getLoadPreferencesUrl();
  try {
    const { data: { preferences: { transactionalEmails, bulkEmails } } } = yield call(
      api.get,
      loadPreferenceRequest.url
    );

    yield put(
      initialize("preferencesForm", {
        transactionalEmails,
        bulkEmails,
      })
    );
  } catch (error) {
    // yield put(loadPreferencesFailed(error));
  }
}

function* handleUpdatePreferences() {
  const data = yield select(getFormValues("preferencesForm"));
  yield put(startSubmit("preferencesForm"));
  const updatePreferencesRequest = getUpdatePreferencesUrl(data);
  try {
    yield call(api.put, updatePreferencesRequest.url, updatePreferencesRequest.config);
    yield put(showAlert("your preferences have been updated successfully"));
    mixpanel.track("preferences.edit", data);
    yield put(stopSubmit("preferencesForm"));
  } catch (error) {
    const errorObject = { _error: "Unexpected error occurred, please try again." };
    yield put(stopSubmit("preferencesForm", errorObject));
  }
}

export function* watchPreferencesRequests(props) {
  yield takeLatest("LOAD_PREFERENCES_REQUEST", handleLoadPreferences);
  yield takeLatest("UPDATE_PREFERENCES_REQUEST", handleUpdatePreferences);
}



// WEBPACK FOOTER //
// ./src/scenes/PreferencesPage/sagas.js